import React from "react";
import { formatImage } from "../utils/mixin";

interface IProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  errorImage?: string;
}

export default function Image({ errorImage, ...props }: IProps) {
  let url = formatImage(props.src);
  if (!url) url = errorImage || "/avatar.png";
  return (
    <img
      alt="Formatted preview"
      {...props}
      src={url}
      onError={(e: any) => (e.target.src = errorImage || "/avatar.png")}
    />
  );
}
